import LocalStorageModel from "../prototypes/LocalStorageModel";
import { ApplePayPaymentCredentialStatus } from "@src/components/page-content/Checkout/Payment.utils";
import type { GooglePayProps } from "@src/components/page-content/Checkout/Payment.utils";
import { GATSBY_CONF_ENV } from "@src/utils/constants";

//
// Model PaymentBrand
//

class PaymentBrandModel extends LocalStorageModel<{
  name: string;
  short_name?: string;
  directlink: boolean;
  apple_pay?: boolean;
  google_pay?: boolean;
  paymentCredentialStatus?: ApplePayPaymentCredentialStatus;
  googlePayProps?: GooglePayProps;
  brand: string;
  id_payment_mode?: string | number;
  priority: number;
  pictures: { id_object_picture: string }[];
}> {
  name = "PaymentBrandModel";
  route = "apiPaymentBrandModel";
  // TODO attention, l'idAttribute n'est pas `id_payment_brand` (car pas migré)
  idAttribute = "id_payment_brand";
  defaults() {
    return { name: "", pictures: [], directlink: false };
  }
  initialize(attributes?: any, options?: any): void {
    // ObjectModel constructor heritage
    super.initialize.apply(this, [attributes, options]);
  }
  isDirectLink() {
    return !!this.get("directlink");
  }

  getName() {
    return this.get("name") || "";
  }
  getShortName(defaultName: boolean = true) {
    return this.get("short_name") || this.getName() || "";
  }
  getBrand() {
    return this.get("brand") || "";
  }
  getIdPicture(): string {
    const model = this,
      pictures = model.get("pictures");
    return (
      (pictures && pictures[0] && (pictures[0].id_object_picture as string)) ||
      ""
    );
  }

  getPaymentCredentialStatus(): ApplePayPaymentCredentialStatus {
    return (
      this.get("paymentCredentialStatus") ||
      ApplePayPaymentCredentialStatus.CREDENTIALS_UNKNOWN
    );
  }

  getPriority(): number {
    return this.get("priority") || 0;
  }

  isSupported(): boolean {
    const model = this;
    if (model.isApplePay()) {
      // On affiche Apple Pay uniquement si une carte est enregistrée dans le wallet client
      const status = model.getPaymentCredentialStatus();
      return (
        status === ApplePayPaymentCredentialStatus.CREDENTIALS_AVAILABLE ||
        (GATSBY_CONF_ENV === "dev" && // en dev, on permet de tester Apple Pay
          (status === ApplePayPaymentCredentialStatus.CREDENTIALS_UNAVAILABLE ||
            status === ApplePayPaymentCredentialStatus.CREDENTIALS_UNKNOWN))
      );
    } else if (model.isGooglePay()) {
      const props = model.get("googlePayProps");
      return !!props;
    }
    return true;
  }

  isApplePay(): boolean {
    return !!this.get("apple_pay");
  }
  isGooglePay(): boolean {
    return !!this.get("google_pay");
  }

  // hasApplePayCredentials(): boolean {
  //   return (
  //     this.isApplePay() &&
  //     this.getPaymentCredentialStatus() ===
  //       ApplePayPaymentCredentialStatus.CREDENTIALS_AVAILABLE
  //   );
  // }

  getCvcLength(): number {
    const model = this;
    const brand = model.get("brand") || "";
    const cvcLength = /^AMEX$/i.test(brand) ? 4 : 3;
    return cvcLength;
  }
}

PaymentBrandModel.prototype.name = "PaymentBrandModel";
PaymentBrandModel.prototype.route = "apiPaymentBrandModel";
// TODO attention, l'idAttribute n'est pas `id_payment_brand` (car pas migré)
PaymentBrandModel.prototype.idAttribute = "id_payment_brand";

export default PaymentBrandModel;
